<template>
  <div>
    <Header></Header>

    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div v-for="item in items" :key="item.id" class="card mb-1 mt-1">
            <h4 class="card-header">{{item.type_name}}: {{item.name}}</h4>
            <br>
            <Actions v-bind:actions="item.actions"></Actions>
          </div>
        </div>
      </div>
    </div>
    <infinite-loading
      @infinite="infiniteItems"
      :identifier="infiniteId"
    ></infinite-loading>
  </div>
</template>

<script>
import CollectionMixin from '../../services/collection_mixin'
import Actions from './triggers/actions'
import Conditions from './triggers/conditions'

export default {
  mixins: [CollectionMixin],
  components: {
    Actions,
    Conditions
  },
  data: function(){
    return {
      resourceName: 'trigger'
    }
  }
}
</script>
